// extracted by mini-css-extract-plugin
export var parcelRow = "_ss-0";